import Echo from "laravel-echo";

export default {
    props: ["modelType", "modelId"],
    data () {
        return {
            channels: [],
            echo: null,
            showChannelModal: false,

            loadingChannelsList: true,
            loadingChannel: true,

            selectedUsers: [],
            selectedChannel: null,

            filters: {
                user_filter: "",
                filter_text: "",
                only_new_messages: true,
                last_date: null
            }
        };
    },
    created () {
        let self = this;
        Bus.$on("update-own-list", (message) => {
            self.updateOwnChannelList(message);
        });
        Bus.$on("channel-list-changed", function () {
            self.getChannelsForModel(self.modelType, self.modelId);
        });
        if (self.modelType && self.modelId) {
            self.getChannelsForModel(self.modelType, self.modelId);
        }
    },

    mounted () {
        if (this.state.team_type === "service_provider" || this.hasFeature("feat_service_provider_portals")) {
            this.echo = new Echo({
                broadcaster: "pusher",
                key: window.pusherKey,
                cluster: "eu",
                encrypted: true
            });

            this.handleUrlParams();

            this.echo.private("update.channel.list")
            .listen("MessengerChannelListChangedEvent", (event) => {
                this.findAndUpdateChannel(event);
            })
            .listen("MessengerChannelCreatedEvent", (event) => {
                this.channels.push(event.messengerChannel);
            });
        }
    },

    beforeDestroy () {
        if (this.state.team_type === "service_provider" || this.hasFeature("feat_service_provider_portals")) {
            if (this.echo != null && this.echo != {}) {
                this.echo.leave("update.channel.list");
            }
            if (window.echo) {
                window.echo.leave("update.channel.list");
            }
        }
    },

    methods: {
        findAndUpdateChannel (event) {
            let eventChannel = event.messengerChannel;
            let index = this.channels.findIndex(listChannel => listChannel.id === eventChannel.id);

            // If the channel list is not available (I.e. the current filters)
            // caused no channel results to be visible OR
            // If the channel is already open and a message is received for the open channel
            // then We don't want to increment or decrement the channel list item
            if (index === -1 || (this.showChannel && this.selectedChannel !== null && this.selectedChannel.id === eventChannel.id)) {
                return;
            }

            this.channels[index].last_message = eventChannel.last_message;
            if (event.type === "sent") {
                this.channels[index].number_of_unread_messages++;
            } else {
                this.channels[index].number_of_unread_messages--;
            }
        },

        // used to updated the sender's own channel list with the latest
        // message for a channel without affecting unread messages count.
        updateOwnChannelList (message) {
            let index = this.channels.findIndex(channel => channel.id === message.messenger_channel_id);
            this.channels[index].last_message = message;
        },

        closeChannel () {
            this.showChannelModal = false;
            this.selectedChannel = null;
            Bus.$emit("closing-channel");
        },

        backToChannelList () {
            this.selectedChannel = null;
        },

        showChannel (channel) {
            this.selectedChannel = null;
            this.loadingChannel = true;
            axios.get("/messenger/channels/" + channel.id, new AppForm({}))
            .then(response => {
                this.selectedChannel = response.data;
                this.showChannelModal = true;
                this.loadingChannel = false;
                Bus.$emit("showing-channel");
            })
            .catch(errors => {
                toastr.error("Could not fetch channel details");
                this.loadingChannel = false;
            });
        },

        toggleChannelModal (value) {
            this.showChannelModal = value;
        },

        handleUrlParams () {
            let url = new URL(document.location);
            let channelId = url.searchParams.get("channel");

            if (channelId) {
                this.toggleChannelModal(true);
                this.showChannel({id: channelId});

                url.searchParams.delete("channel");
                history.pushState(null, null, url);
            }
        },

        getChannelsForModel (modelType, modelId) {
            axios.get(`/messenger/channels/${modelType}/${modelId}`)
            .then((response) => {
                this.channels = response.data;
            });
        },

        searchChannels: _.debounce(function () {
            this.loadingChannelsList = true;
            //only for infinite loading, results refresh when filtering
            this.filters.last_date = null;

            axios.get(this.infiniteHandlerUrl, {
                params: this.filters,
                take: 10,
            })
            .then((response) => {
                if (response.data.length > 0) {
                    this.filters.last_date = response.data[response.data.length - 1].last_message.sent_at;
                }
                this.channels = response.data;
            })
            .then(() => {
                this.loadingChannelsList = false;
            })
            .catch((error) => {
                this.loadingChannelsList = false;
                toastr.error("Error While Searching Channels! " + error.message);
            });
        }, 300),

        handleScroll (event) {
            let {scrollTop, clientHeight, scrollHeight} = event.target;
            // The ten is the value passed for the number of records to be returned when the handler is called
            this.updateScrollState(scrollTop, clientHeight, scrollHeight, 3);
        },

        updateScrollState (scrollTop, clientHeight, scrollHeight, take = 10) {
            if (clientHeight + scrollTop === scrollHeight) {
                if (document.location.href.includes('tasks')) {
                    // Task List
                    this.infiniteHandler();
                } else {
                    // Messenger list
                    this.infiniteChannelListHandler(this.infiniteHandlerUrl, this.filters, take);
                }
            }
        },

        infiniteChannelListHandler (url, params = {}, take = 10) {
            if (this.loadingChannelsList) {
                return false;
            }
            this.loadingChannelsList = true;

            axios.get(url, new AppForm({
                params: params,
                take: take
            })).then((response) => {
                if (response.data.length > 0) {
                    this.filters.last_date = response.data[response.data.length - 1].last_message.sent_at;
                    this.channels = this.channels.concat(response.data);
                }
            })
            .then(() => {
                this.loadingChannelsList = false;
            })
            .catch((error) => {
                this.loadingChannelsList = false;
                toastr.error("Could not refresh channel list. " + error.message);
            });
        },
    }
};
